import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import PlusGlyph from './PlusGlyph'

interface Props {
    label: string
    to?: string
    onClick?: () => void
    disabled?: boolean
    disabledLabel?: string
    className?: string
}

const CreateButton: React.FC<Props> = ({
    label,
    to,
    onClick,
    disabled = false,
    disabledLabel,
    className,
}) => {
    if (disabled) {
        return (
            <Host className={className}>
                <Btn as='button' type='button' disabled>
                    <PlusGlyph />
                    <span>{disabledLabel ?? label}</span>
                </Btn>
            </Host>
        )
    }
    if (to) {
        return (
            <Host className={className}>
                <Btn as={Link} to={to} onClick={onClick}>
                    <PlusGlyph />
                    <span>{label}</span>
                </Btn>
            </Host>
        )
    }
    return (
        <Host className={className}>
            <Btn as='button' type='button' onClick={onClick}>
                <PlusGlyph />
                <span>{label}</span>
            </Btn>
        </Host>
    )
}

export default CreateButton

const Host = styled.div`
    display: none;

    @media (min-width: 541px) {
        display: inline-flex;
        flex-shrink: 0;
    }
`

const Btn = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    height: 2.8rem;
    padding: 0 1rem;
    border: 0;
    border-radius: 0.8125rem;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.ink};
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    font-weight: 600;
    letter-spacing: 0.01em;
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
    transition:
        transform ${({ theme }) => theme.motion.fast} ease,
        background ${({ theme }) => theme.motion.fast} ease,
        box-shadow ${({ theme }) => theme.motion.fast} ease;

    svg {
        width: 0.9375rem;
        height: 0.9375rem;
    }

    &:hover:not(:disabled) {
        background: ${({ theme }) => theme.colors.accentDeep};
        transform: translateY(-1px);
        box-shadow: ${({ theme }) => theme.shadows.submitHover};
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
        background: ${({ theme }) => theme.colors.line};
        color: ${({ theme }) => theme.colors.ink3};
    }
`
